import 'moment-duration-format';
import { Moment } from 'moment';
import { MOMENT_UNIT } from '@core/utils/moment';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getMomentFromDate } from '@core/utils/date-time';
import { FORMAT } from '@core/utils/formats';
import moment from 'moment';

/**
 * Validates the form value from string as after a min datetime.
 * @param {string} minValue
 * @param {MOMENT_UNIT} granularity
 * @returns {ValidatorFn}
 */
export function minDatetime(minValue: string, granularity: MOMENT_UNIT = MOMENT_UNIT.DAYS, format: string = FORMAT.DATETIME_SERVER): ValidatorFn {
    const minMoment: Moment = moment(minValue, format);

    return (control: AbstractControl): ValidationErrors | null => {
        const formItem: any = control;
        const formMoment: Moment = moment((formItem as FormControl).value, format);

        let isValid: boolean = false;

        if (formMoment && formMoment.isValid()) {
            isValid = formMoment.isSameOrAfter(minMoment, granularity);
        }

        return isValid ? null : { minDatetime: true };
    }
}
